import api from '@/libs/axiosInstance';

export const pusherService = {
  authenticate: async (socketId: string, channel: string) => {
    const response = await api.post('/pusher/auth', { socketId, channel });
    return response.data;
  },
};
